var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _ellipse94, _ellipse95, _ellipse96, _ellipse97, _ellipse98, _ellipse99, _ellipse100, _ellipse101, _ellipse102, _ellipse103, _ellipse104, _ellipse105, _ellipse106, _ellipse107, _ellipse108, _ellipse109, _ellipse110, _ellipse111, _ellipse112, _ellipse113, _ellipse114, _ellipse115, _ellipse116, _ellipse117, _ellipse118, _ellipse119, _ellipse120, _ellipse121, _ellipse122, _ellipse123, _ellipse124, _ellipse125, _ellipse126, _ellipse127, _ellipse128, _ellipse129, _ellipse130, _ellipse131, _ellipse132, _ellipse133, _ellipse134, _ellipse135, _ellipse136, _ellipse137, _ellipse138, _ellipse139, _ellipse140, _ellipse141, _ellipse142, _ellipse143, _ellipse144, _ellipse145, _ellipse146, _ellipse147, _ellipse148, _ellipse149, _ellipse150, _ellipse151, _ellipse152, _ellipse153, _ellipse154, _ellipse155, _ellipse156, _ellipse157, _ellipse158, _ellipse159, _ellipse160, _ellipse161, _ellipse162, _ellipse163, _ellipse164, _ellipse165, _ellipse166, _ellipse167, _ellipse168, _ellipse169, _ellipse170, _ellipse171, _ellipse172, _ellipse173, _ellipse174, _ellipse175, _ellipse176, _ellipse177, _ellipse178, _ellipse179, _ellipse180, _ellipse181, _ellipse182, _ellipse183, _ellipse184, _ellipse185, _ellipse186, _ellipse187, _ellipse188, _ellipse189, _ellipse190, _ellipse191, _ellipse192, _ellipse193, _ellipse194, _ellipse195, _ellipse196, _ellipse197, _ellipse198, _ellipse199, _ellipse200, _ellipse201, _ellipse202, _ellipse203, _ellipse204, _ellipse205, _ellipse206, _ellipse207, _ellipse208, _ellipse209, _ellipse210, _ellipse211, _ellipse212, _ellipse213, _ellipse214, _ellipse215, _ellipse216, _ellipse217, _ellipse218, _ellipse219, _ellipse220, _ellipse221, _ellipse222, _ellipse223, _ellipse224, _ellipse225, _ellipse226, _ellipse227, _ellipse228, _ellipse229, _ellipse230, _ellipse231, _ellipse232, _ellipse233, _ellipse234, _ellipse235, _ellipse236, _ellipse237, _ellipse238, _ellipse239, _ellipse240, _ellipse241, _ellipse242, _ellipse243, _ellipse244, _ellipse245, _ellipse246, _ellipse247, _ellipse248, _ellipse249, _ellipse250, _ellipse251, _ellipse252, _ellipse253, _ellipse254, _ellipse255, _ellipse256, _ellipse257, _ellipse258, _ellipse259, _ellipse260, _ellipse261, _ellipse262, _ellipse263, _ellipse264, _ellipse265, _ellipse266, _ellipse267, _ellipse268, _ellipse269, _ellipse270, _ellipse271, _ellipse272, _ellipse273, _ellipse274, _ellipse275, _ellipse276, _ellipse277, _ellipse278, _ellipse279, _ellipse280, _ellipse281, _ellipse282, _ellipse283, _ellipse284, _ellipse285, _ellipse286, _ellipse287, _ellipse288, _ellipse289, _ellipse290, _ellipse291, _ellipse292, _ellipse293, _ellipse294, _ellipse295, _ellipse296, _ellipse297, _ellipse298, _ellipse299, _ellipse300, _ellipse301, _ellipse302, _ellipse303, _ellipse304, _ellipse305, _ellipse306, _ellipse307, _ellipse308, _ellipse309, _ellipse310, _ellipse311, _ellipse312, _ellipse313, _ellipse314, _ellipse315, _ellipse316, _ellipse317, _ellipse318, _ellipse319, _ellipse320, _ellipse321, _ellipse322, _ellipse323, _ellipse324, _ellipse325, _ellipse326, _ellipse327, _ellipse328, _ellipse329, _ellipse330, _ellipse331, _ellipse332, _ellipse333, _ellipse334, _ellipse335, _ellipse336, _ellipse337, _ellipse338, _ellipse339, _ellipse340, _ellipse341, _ellipse342, _ellipse343, _ellipse344, _ellipse345, _ellipse346, _ellipse347, _ellipse348, _ellipse349, _ellipse350, _ellipse351, _ellipse352, _ellipse353, _ellipse354, _ellipse355, _ellipse356, _ellipse357, _ellipse358, _ellipse359, _ellipse360, _ellipse361, _ellipse362, _ellipse363, _ellipse364, _ellipse365, _ellipse366, _ellipse367, _ellipse368, _ellipse369, _ellipse370, _ellipse371, _ellipse372, _ellipse373, _ellipse374, _ellipse375, _ellipse376, _ellipse377, _ellipse378, _ellipse379, _ellipse380, _ellipse381, _ellipse382, _ellipse383, _ellipse384, _ellipse385, _ellipse386, _ellipse387, _ellipse388, _ellipse389, _ellipse390, _ellipse391, _ellipse392, _ellipse393, _ellipse394, _ellipse395, _ellipse396, _ellipse397, _ellipse398, _ellipse399, _ellipse400, _ellipse401, _ellipse402, _ellipse403, _ellipse404, _ellipse405, _ellipse406, _ellipse407, _ellipse408, _ellipse409, _ellipse410, _ellipse411, _ellipse412, _ellipse413, _ellipse414, _ellipse415, _ellipse416, _ellipse417, _ellipse418, _ellipse419, _ellipse420, _ellipse421, _ellipse422, _ellipse423, _ellipse424, _ellipse425, _ellipse426, _ellipse427, _ellipse428, _ellipse429, _ellipse430, _ellipse431, _ellipse432, _ellipse433, _ellipse434, _ellipse435, _ellipse436, _ellipse437, _ellipse438, _ellipse439, _ellipse440, _ellipse441, _ellipse442, _ellipse443, _ellipse444, _ellipse445, _ellipse446, _ellipse447, _ellipse448, _ellipse449, _ellipse450, _ellipse451, _ellipse452, _ellipse453, _ellipse454, _ellipse455, _ellipse456, _ellipse457, _ellipse458, _ellipse459, _ellipse460, _ellipse461, _ellipse462, _ellipse463, _ellipse464, _ellipse465, _ellipse466, _ellipse467, _ellipse468, _ellipse469, _ellipse470, _ellipse471, _ellipse472, _ellipse473, _ellipse474, _ellipse475, _ellipse476, _ellipse477, _ellipse478, _ellipse479, _ellipse480, _ellipse481, _ellipse482, _ellipse483, _ellipse484, _ellipse485, _ellipse486, _ellipse487, _ellipse488, _ellipse489, _ellipse490, _ellipse491, _ellipse492, _ellipse493, _ellipse494, _ellipse495, _ellipse496, _ellipse497, _ellipse498, _ellipse499, _ellipse500, _ellipse501, _ellipse502, _ellipse503, _ellipse504, _ellipse505, _ellipse506, _ellipse507, _ellipse508, _ellipse509, _ellipse510, _ellipse511, _ellipse512, _ellipse513, _ellipse514, _ellipse515, _ellipse516, _ellipse517, _ellipse518, _ellipse519, _ellipse520, _ellipse521, _ellipse522, _ellipse523, _ellipse524, _ellipse525, _ellipse526, _ellipse527, _ellipse528, _ellipse529, _ellipse530, _ellipse531, _ellipse532, _ellipse533, _ellipse534, _ellipse535, _ellipse536, _ellipse537, _ellipse538, _ellipse539, _ellipse540, _ellipse541, _ellipse542, _ellipse543, _ellipse544, _ellipse545, _ellipse546, _ellipse547, _ellipse548, _ellipse549, _ellipse550, _ellipse551, _ellipse552, _ellipse553, _ellipse554, _ellipse555, _ellipse556, _ellipse557, _ellipse558, _ellipse559, _ellipse560, _ellipse561, _ellipse562, _ellipse563, _ellipse564, _ellipse565, _ellipse566, _ellipse567, _ellipse568, _ellipse569, _ellipse570, _ellipse571, _ellipse572, _ellipse573, _ellipse574, _ellipse575, _ellipse576, _ellipse577, _ellipse578, _ellipse579, _ellipse580, _ellipse581, _ellipse582, _ellipse583, _ellipse584, _ellipse585, _ellipse586, _ellipse587, _ellipse588, _ellipse589, _ellipse590, _ellipse591, _ellipse592, _ellipse593, _ellipse594, _ellipse595, _ellipse596, _ellipse597, _ellipse598, _ellipse599, _ellipse600, _ellipse601, _ellipse602, _ellipse603, _ellipse604, _ellipse605, _ellipse606, _ellipse607, _ellipse608, _ellipse609, _ellipse610, _ellipse611, _ellipse612, _ellipse613, _ellipse614, _ellipse615, _ellipse616, _ellipse617, _ellipse618, _ellipse619, _ellipse620, _ellipse621, _ellipse622, _ellipse623, _ellipse624, _ellipse625, _ellipse626, _ellipse627, _ellipse628, _ellipse629, _ellipse630, _ellipse631, _ellipse632, _ellipse633, _ellipse634, _ellipse635, _ellipse636, _ellipse637, _ellipse638, _ellipse639, _ellipse640, _ellipse641, _ellipse642, _ellipse643, _ellipse644, _ellipse645, _ellipse646, _ellipse647, _ellipse648, _ellipse649, _ellipse650, _ellipse651, _ellipse652, _ellipse653, _ellipse654, _ellipse655, _ellipse656, _ellipse657, _ellipse658, _ellipse659, _ellipse660, _ellipse661, _ellipse662, _ellipse663, _ellipse664, _ellipse665, _ellipse666, _ellipse667, _ellipse668, _ellipse669, _ellipse670, _ellipse671, _ellipse672, _ellipse673, _ellipse674, _ellipse675, _ellipse676, _ellipse677, _ellipse678, _ellipse679, _ellipse680, _ellipse681, _ellipse682, _ellipse683, _ellipse684, _ellipse685, _ellipse686, _ellipse687, _ellipse688, _ellipse689, _ellipse690, _ellipse691, _ellipse692, _ellipse693, _ellipse694, _ellipse695, _ellipse696, _ellipse697, _ellipse698, _ellipse699, _ellipse700, _ellipse701, _ellipse702, _ellipse703, _ellipse704, _ellipse705, _ellipse706, _ellipse707, _ellipse708, _ellipse709, _ellipse710, _ellipse711, _ellipse712, _ellipse713, _ellipse714, _ellipse715, _ellipse716, _ellipse717, _ellipse718, _ellipse719, _ellipse720, _ellipse721, _ellipse722, _ellipse723, _ellipse724, _ellipse725, _ellipse726, _ellipse727, _ellipse728, _ellipse729, _ellipse730, _ellipse731, _ellipse732, _ellipse733, _ellipse734, _ellipse735, _ellipse736, _ellipse737, _ellipse738, _ellipse739, _ellipse740, _ellipse741, _ellipse742, _ellipse743, _ellipse744, _ellipse745, _ellipse746, _ellipse747, _ellipse748, _ellipse749, _ellipse750, _ellipse751, _ellipse752, _ellipse753, _ellipse754, _ellipse755, _ellipse756, _ellipse757, _ellipse758, _ellipse759, _ellipse760, _ellipse761, _ellipse762, _ellipse763, _ellipse764, _ellipse765, _ellipse766, _ellipse767, _ellipse768, _ellipse769, _ellipse770, _ellipse771, _ellipse772, _ellipse773, _ellipse774, _ellipse775, _ellipse776, _ellipse777, _ellipse778, _ellipse779, _ellipse780, _ellipse781, _ellipse782, _ellipse783, _ellipse784, _ellipse785, _ellipse786, _ellipse787, _ellipse788, _ellipse789, _ellipse790, _ellipse791, _ellipse792, _ellipse793, _ellipse794, _ellipse795, _ellipse796, _ellipse797, _ellipse798, _ellipse799, _ellipse800, _ellipse801, _ellipse802, _ellipse803, _ellipse804, _ellipse805, _ellipse806, _ellipse807, _ellipse808, _ellipse809, _ellipse810, _ellipse811;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 927,
    viewBox: "0 0 1440 927",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.134,
    cy: 1.25924,
    rx: 0.851568,
    ry: 0.393269,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.869,
    cy: 1.25924,
    rx: 0.85157,
    ry: 0.393269,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.604,
    cy: 1.25924,
    rx: 0.851558,
    ry: 0.393269,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 537.339,
    cy: 1.25924,
    rx: 0.851523,
    ry: 0.393269,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 665.074,
    cy: 1.25924,
    rx: 0.85157,
    ry: 0.393269,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 792.809,
    cy: 1.25924,
    rx: 0.851476,
    ry: 0.393269,
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 920.544,
    cy: 1.25924,
    rx: 0.851593,
    ry: 0.393269,
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1048.28,
    cy: 1.25924,
    rx: 0.851546,
    ry: 0.393269,
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1176.01,
    cy: 1.25924,
    rx: 0.851546,
    ry: 0.393269,
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1303.75,
    cy: 1.25924,
    rx: 0.851593,
    ry: 0.393269,
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.712,
    cy: 40.5852,
    rx: 0.851567,
    ry: 0.393268,
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 324.447,
    cy: 40.5852,
    rx: 0.85157,
    ry: 0.393268,
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.182,
    cy: 40.5852,
    rx: 0.851581,
    ry: 0.393268,
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 579.917,
    cy: 40.5852,
    rx: 0.85157,
    ry: 0.393268,
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.652,
    cy: 40.5852,
    rx: 0.851546,
    ry: 0.393268,
    fill: "white"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 835.387,
    cy: 40.5852,
    rx: 0.851546,
    ry: 0.393268,
    fill: "white"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 963.122,
    cy: 40.5852,
    rx: 0.851593,
    ry: 0.393268,
    fill: "white"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1090.86,
    cy: 40.5852,
    rx: 0.851593,
    ry: 0.393268,
    fill: "white"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1218.59,
    cy: 40.5852,
    rx: 0.851546,
    ry: 0.393268,
    fill: "white"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1346.33,
    cy: 40.5852,
    rx: 0.851593,
    ry: 0.393268,
    fill: "white"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.071,
    cy: 79.913,
    rx: 0.851567,
    ry: 0.393267,
    fill: "white"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.806,
    cy: 79.913,
    rx: 0.851564,
    ry: 0.393267,
    fill: "white"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.541,
    cy: 79.913,
    rx: 0.851558,
    ry: 0.393267,
    fill: "white"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.276,
    cy: 79.913,
    rx: 0.851605,
    ry: 0.393267,
    fill: "white"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 631.011,
    cy: 79.913,
    rx: 0.851546,
    ry: 0.393267,
    fill: "white"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 758.746,
    cy: 79.913,
    rx: 0.851546,
    ry: 0.393267,
    fill: "white"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 886.481,
    cy: 79.913,
    rx: 0.85157,
    ry: 0.393267,
    fill: "white"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1014.22,
    cy: 79.913,
    rx: 0.851593,
    ry: 0.393267,
    fill: "white"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1141.95,
    cy: 79.913,
    rx: 0.851546,
    ry: 0.393267,
    fill: "white"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1269.69,
    cy: 79.913,
    rx: 0.851593,
    ry: 0.393267,
    fill: "white"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.555,
    cy: 119.24,
    rx: 0.851566,
    ry: 0.39327,
    fill: "white"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.29,
    cy: 119.24,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.025,
    cy: 119.24,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 494.76,
    cy: 119.24,
    rx: 0.851558,
    ry: 0.39327,
    fill: "white"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 622.495,
    cy: 119.24,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 750.23,
    cy: 119.24,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 877.966,
    cy: 119.24,
    rx: 0.851476,
    ry: 0.39327,
    fill: "white"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1005.7,
    cy: 119.24,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1133.44,
    cy: 119.24,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1261.17,
    cy: 119.24,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.165,
    cy: 158.568,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.9,
    cy: 158.568,
    rx: 0.851587,
    ry: 0.39327,
    fill: "white"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.635,
    cy: 158.568,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 554.37,
    cy: 158.568,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 682.105,
    cy: 158.568,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 809.84,
    cy: 158.568,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 937.575,
    cy: 158.568,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1065.31,
    cy: 158.568,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1193.05,
    cy: 158.568,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1320.78,
    cy: 158.568,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.618,
    cy: 197.894,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.353,
    cy: 197.894,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 401.088,
    cy: 197.894,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 528.823,
    cy: 197.894,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.558,
    cy: 197.894,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 784.293,
    cy: 197.894,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.028,
    cy: 197.894,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1039.76,
    cy: 197.894,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1167.5,
    cy: 197.894,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1295.23,
    cy: 197.894,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.165,
    cy: 237.22,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.9,
    cy: 237.22,
    rx: 0.851587,
    ry: 0.39327,
    fill: "white"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.635,
    cy: 237.22,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 554.37,
    cy: 237.22,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 682.105,
    cy: 237.22,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 809.84,
    cy: 237.22,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 937.575,
    cy: 237.22,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1065.31,
    cy: 237.22,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1193.05,
    cy: 237.22,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1320.78,
    cy: 237.22,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.586,
    cy: 277.334,
    rx: 0.851567,
    ry: 0.39327,
    fill: "white"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.322,
    cy: 277.334,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 384.057,
    cy: 277.334,
    rx: 0.851558,
    ry: 0.39327,
    fill: "white"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.792,
    cy: 277.334,
    rx: 0.851605,
    ry: 0.39327,
    fill: "white"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 639.527,
    cy: 277.334,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 767.262,
    cy: 277.334,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 894.997,
    cy: 277.334,
    rx: 0.85164,
    ry: 0.39327,
    fill: "white"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1022.73,
    cy: 277.334,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1150.47,
    cy: 277.334,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1278.2,
    cy: 277.334,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.681,
    cy: 316.66,
    rx: 0.851567,
    ry: 0.39327,
    fill: "white"
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.416,
    cy: 316.66,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 435.151,
    cy: 316.66,
    rx: 0.851605,
    ry: 0.39327,
    fill: "white"
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 562.886,
    cy: 316.66,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 690.621,
    cy: 316.66,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 818.356,
    cy: 316.66,
    rx: 0.85164,
    ry: 0.39327,
    fill: "white"
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 946.091,
    cy: 316.66,
    rx: 0.851453,
    ry: 0.39327,
    fill: "white"
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1073.83,
    cy: 316.66,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1201.56,
    cy: 316.66,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.649,
    cy: 355.988,
    rx: 0.851567,
    ry: 0.39327,
    fill: "white"
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.384,
    cy: 355.988,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.119,
    cy: 355.988,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 545.854,
    cy: 355.988,
    rx: 0.851617,
    ry: 0.39327,
    fill: "white"
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 673.589,
    cy: 355.988,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 801.325,
    cy: 355.988,
    rx: 0.851476,
    ry: 0.39327,
    fill: "white"
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 929.06,
    cy: 355.988,
    rx: 0.85164,
    ry: 0.39327,
    fill: "white"
  })), _ellipse97 || (_ellipse97 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1056.79,
    cy: 355.988,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse98 || (_ellipse98 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1184.53,
    cy: 355.988,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse99 || (_ellipse99 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1312.27,
    cy: 355.988,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse100 || (_ellipse100 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.743,
    cy: 395.313,
    rx: 0.851576,
    ry: 0.393259,
    fill: "white"
  })), _ellipse101 || (_ellipse101 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.478,
    cy: 395.313,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse102 || (_ellipse102 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.213,
    cy: 395.313,
    rx: 0.851605,
    ry: 0.393259,
    fill: "white"
  })), _ellipse103 || (_ellipse103 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 596.948,
    cy: 395.313,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse104 || (_ellipse104 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 724.684,
    cy: 395.313,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse105 || (_ellipse105 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 852.418,
    cy: 395.313,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse106 || (_ellipse106 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 980.154,
    cy: 395.313,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse107 || (_ellipse107 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1107.89,
    cy: 395.313,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse108 || (_ellipse108 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1235.62,
    cy: 395.313,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse109 || (_ellipse109 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1363.36,
    cy: 395.313,
    rx: 0.851874,
    ry: 0.393259,
    fill: "white"
  })), _ellipse110 || (_ellipse110 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.618,
    cy: 434.641,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse111 || (_ellipse111 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.353,
    cy: 434.641,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse112 || (_ellipse112 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 401.088,
    cy: 434.641,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse113 || (_ellipse113 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 528.823,
    cy: 434.641,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse114 || (_ellipse114 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.558,
    cy: 434.641,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse115 || (_ellipse115 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 784.293,
    cy: 434.641,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse116 || (_ellipse116 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.028,
    cy: 434.641,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse117 || (_ellipse117 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1039.76,
    cy: 434.641,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse118 || (_ellipse118 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1167.5,
    cy: 434.641,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse119 || (_ellipse119 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1295.23,
    cy: 434.641,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse120 || (_ellipse120 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.165,
    cy: 473.967,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse121 || (_ellipse121 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.9,
    cy: 473.967,
    rx: 0.851587,
    ry: 0.393259,
    fill: "white"
  })), _ellipse122 || (_ellipse122 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.635,
    cy: 473.967,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse123 || (_ellipse123 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 554.37,
    cy: 473.967,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse124 || (_ellipse124 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 682.105,
    cy: 473.967,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse125 || (_ellipse125 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 809.84,
    cy: 473.967,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse126 || (_ellipse126 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 937.575,
    cy: 473.967,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse127 || (_ellipse127 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1065.31,
    cy: 473.967,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse128 || (_ellipse128 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1193.05,
    cy: 473.967,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse129 || (_ellipse129 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1320.78,
    cy: 473.967,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse130 || (_ellipse130 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.775,
    cy: 517.227,
    rx: 0.851564,
    ry: 0.393259,
    fill: "white"
  })), _ellipse131 || (_ellipse131 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 358.51,
    cy: 517.227,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse132 || (_ellipse132 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.245,
    cy: 517.227,
    rx: 0.851558,
    ry: 0.393259,
    fill: "white"
  })), _ellipse133 || (_ellipse133 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 613.98,
    cy: 517.227,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse134 || (_ellipse134 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 741.715,
    cy: 517.227,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse135 || (_ellipse135 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 869.45,
    cy: 517.227,
    rx: 0.851476,
    ry: 0.393259,
    fill: "white"
  })), _ellipse136 || (_ellipse136 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 997.185,
    cy: 517.227,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse137 || (_ellipse137 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1124.92,
    cy: 517.227,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse138 || (_ellipse138 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1252.66,
    cy: 517.227,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse139 || (_ellipse139 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1380.39,
    cy: 517.227,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse140 || (_ellipse140 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.681,
    cy: 560.486,
    rx: 0.851567,
    ry: 0.39328,
    fill: "white"
  })), _ellipse141 || (_ellipse141 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.416,
    cy: 560.486,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse142 || (_ellipse142 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 435.151,
    cy: 560.486,
    rx: 0.851605,
    ry: 0.39328,
    fill: "white"
  })), _ellipse143 || (_ellipse143 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 562.886,
    cy: 560.486,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse144 || (_ellipse144 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 690.621,
    cy: 560.486,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse145 || (_ellipse145 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 818.356,
    cy: 560.486,
    rx: 0.85164,
    ry: 0.39328,
    fill: "white"
  })), _ellipse146 || (_ellipse146 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 946.091,
    cy: 560.486,
    rx: 0.851453,
    ry: 0.39328,
    fill: "white"
  })), _ellipse147 || (_ellipse147 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1073.83,
    cy: 560.486,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse148 || (_ellipse148 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1201.56,
    cy: 560.486,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse149 || (_ellipse149 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1329.3,
    cy: 560.486,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse150 || (_ellipse150 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.806,
    cy: 602.96,
    rx: 0.851564,
    ry: 0.39328,
    fill: "white"
  })), _ellipse151 || (_ellipse151 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.541,
    cy: 602.96,
    rx: 0.851558,
    ry: 0.39328,
    fill: "white"
  })), _ellipse152 || (_ellipse152 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.276,
    cy: 602.96,
    rx: 0.851605,
    ry: 0.39328,
    fill: "white"
  })), _ellipse153 || (_ellipse153 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 631.011,
    cy: 602.96,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse154 || (_ellipse154 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 758.746,
    cy: 602.96,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse155 || (_ellipse155 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 886.481,
    cy: 602.96,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse156 || (_ellipse156 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1014.22,
    cy: 602.96,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse157 || (_ellipse157 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1141.95,
    cy: 602.96,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse158 || (_ellipse158 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1269.69,
    cy: 602.96,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse159 || (_ellipse159 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.712,
    cy: 646.22,
    rx: 0.851567,
    ry: 0.39328,
    fill: "white"
  })), _ellipse160 || (_ellipse160 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 324.447,
    cy: 646.22,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse161 || (_ellipse161 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.182,
    cy: 646.22,
    rx: 0.851581,
    ry: 0.39328,
    fill: "white"
  })), _ellipse162 || (_ellipse162 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 579.917,
    cy: 646.22,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse163 || (_ellipse163 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.652,
    cy: 646.22,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse164 || (_ellipse164 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 835.387,
    cy: 646.22,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse165 || (_ellipse165 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 963.122,
    cy: 646.22,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse166 || (_ellipse166 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1090.86,
    cy: 646.22,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse167 || (_ellipse167 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1218.59,
    cy: 646.22,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse168 || (_ellipse168 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1346.33,
    cy: 646.22,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse169 || (_ellipse169 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.618,
    cy: 689.478,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse170 || (_ellipse170 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.353,
    cy: 689.478,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse171 || (_ellipse171 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 401.088,
    cy: 689.478,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse172 || (_ellipse172 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 528.823,
    cy: 689.478,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse173 || (_ellipse173 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.558,
    cy: 689.478,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse174 || (_ellipse174 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 784.293,
    cy: 689.478,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse175 || (_ellipse175 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.028,
    cy: 689.478,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse176 || (_ellipse176 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1039.76,
    cy: 689.478,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse177 || (_ellipse177 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1167.5,
    cy: 689.478,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse178 || (_ellipse178 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1295.23,
    cy: 689.478,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse179 || (_ellipse179 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.712,
    cy: 732.74,
    rx: 0.851567,
    ry: 0.393259,
    fill: "white"
  })), _ellipse180 || (_ellipse180 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 324.447,
    cy: 732.74,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse181 || (_ellipse181 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.182,
    cy: 732.74,
    rx: 0.851581,
    ry: 0.393259,
    fill: "white"
  })), _ellipse182 || (_ellipse182 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 579.917,
    cy: 732.74,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse183 || (_ellipse183 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.652,
    cy: 732.74,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse184 || (_ellipse184 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 835.387,
    cy: 732.74,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse185 || (_ellipse185 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 963.122,
    cy: 732.74,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse186 || (_ellipse186 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1090.86,
    cy: 732.74,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse187 || (_ellipse187 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1218.59,
    cy: 732.74,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse188 || (_ellipse188 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.649,
    cy: 772.066,
    rx: 0.851567,
    ry: 0.393259,
    fill: "white"
  })), _ellipse189 || (_ellipse189 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.384,
    cy: 772.066,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse190 || (_ellipse190 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.119,
    cy: 772.066,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse191 || (_ellipse191 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 545.854,
    cy: 772.066,
    rx: 0.851617,
    ry: 0.393259,
    fill: "white"
  })), _ellipse192 || (_ellipse192 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 673.589,
    cy: 772.066,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse193 || (_ellipse193 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 801.325,
    cy: 772.066,
    rx: 0.851476,
    ry: 0.393259,
    fill: "white"
  })), _ellipse194 || (_ellipse194 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 929.06,
    cy: 772.066,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse195 || (_ellipse195 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1056.79,
    cy: 772.066,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse196 || (_ellipse196 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1184.53,
    cy: 772.066,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse197 || (_ellipse197 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1184.53,
    cy: 772.066,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse198 || (_ellipse198 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.775,
    cy: 811.393,
    rx: 0.851564,
    ry: 0.393259,
    fill: "white"
  })), _ellipse199 || (_ellipse199 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 358.51,
    cy: 811.393,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse200 || (_ellipse200 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.245,
    cy: 811.393,
    rx: 0.851558,
    ry: 0.393259,
    fill: "white"
  })), _ellipse201 || (_ellipse201 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 613.98,
    cy: 811.393,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse202 || (_ellipse202 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 741.715,
    cy: 811.393,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse203 || (_ellipse203 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 869.45,
    cy: 811.393,
    rx: 0.851476,
    ry: 0.393259,
    fill: "white"
  })), _ellipse204 || (_ellipse204 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 997.185,
    cy: 811.393,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse205 || (_ellipse205 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1124.92,
    cy: 811.393,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse206 || (_ellipse206 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1252.66,
    cy: 811.393,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse207 || (_ellipse207 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1346.33,
    cy: 732.74,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse208 || (_ellipse208 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.712,
    cy: 5.19161,
    rx: 0.851567,
    ry: 0.393269,
    fill: "white"
  })), _ellipse209 || (_ellipse209 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 324.447,
    cy: 5.19161,
    rx: 0.85157,
    ry: 0.393269,
    fill: "white"
  })), _ellipse210 || (_ellipse210 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 452.182,
    cy: 5.19161,
    rx: 0.851581,
    ry: 0.393269,
    fill: "white"
  })), _ellipse211 || (_ellipse211 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 579.917,
    cy: 5.19161,
    rx: 0.85157,
    ry: 0.393269,
    fill: "white"
  })), _ellipse212 || (_ellipse212 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.652,
    cy: 5.19161,
    rx: 0.851546,
    ry: 0.393269,
    fill: "white"
  })), _ellipse213 || (_ellipse213 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 835.387,
    cy: 5.19161,
    rx: 0.851546,
    ry: 0.393269,
    fill: "white"
  })), _ellipse214 || (_ellipse214 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 963.122,
    cy: 5.19161,
    rx: 0.851593,
    ry: 0.393269,
    fill: "white"
  })), _ellipse215 || (_ellipse215 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1090.86,
    cy: 5.19161,
    rx: 0.851593,
    ry: 0.393269,
    fill: "white"
  })), _ellipse216 || (_ellipse216 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1218.59,
    cy: 5.19161,
    rx: 0.851546,
    ry: 0.393269,
    fill: "white"
  })), _ellipse217 || (_ellipse217 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1346.33,
    cy: 5.19161,
    rx: 0.851593,
    ry: 0.393269,
    fill: "white"
  })), _ellipse218 || (_ellipse218 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.29,
    cy: 44.5175,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse219 || (_ellipse219 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.025,
    cy: 44.5175,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse220 || (_ellipse220 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 494.76,
    cy: 44.5175,
    rx: 0.851558,
    ry: 0.39327,
    fill: "white"
  })), _ellipse221 || (_ellipse221 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 622.496,
    cy: 44.5175,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse222 || (_ellipse222 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 750.231,
    cy: 44.5175,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse223 || (_ellipse223 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 877.966,
    cy: 44.5175,
    rx: 0.851476,
    ry: 0.39327,
    fill: "white"
  })), _ellipse224 || (_ellipse224 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1005.7,
    cy: 44.5175,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse225 || (_ellipse225 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1133.44,
    cy: 44.5175,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse226 || (_ellipse226 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1261.17,
    cy: 44.5175,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse227 || (_ellipse227 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1388.91,
    cy: 44.5175,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse228 || (_ellipse228 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.649,
    cy: 83.8454,
    rx: 0.851567,
    ry: 0.39327,
    fill: "white"
  })), _ellipse229 || (_ellipse229 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.384,
    cy: 83.8454,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse230 || (_ellipse230 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.119,
    cy: 83.8454,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse231 || (_ellipse231 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 545.855,
    cy: 83.8454,
    rx: 0.851617,
    ry: 0.39327,
    fill: "white"
  })), _ellipse232 || (_ellipse232 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 673.59,
    cy: 83.8454,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse233 || (_ellipse233 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 801.325,
    cy: 83.8454,
    rx: 0.851476,
    ry: 0.39327,
    fill: "white"
  })), _ellipse234 || (_ellipse234 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 929.06,
    cy: 83.8454,
    rx: 0.85164,
    ry: 0.39327,
    fill: "white"
  })), _ellipse235 || (_ellipse235 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1056.79,
    cy: 83.8454,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse236 || (_ellipse236 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1184.53,
    cy: 83.8454,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse237 || (_ellipse237 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1312.27,
    cy: 83.8454,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse238 || (_ellipse238 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.134,
    cy: 123.172,
    rx: 0.851568,
    ry: 0.39327,
    fill: "white"
  })), _ellipse239 || (_ellipse239 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.869,
    cy: 123.172,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse240 || (_ellipse240 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.604,
    cy: 123.172,
    rx: 0.851558,
    ry: 0.39327,
    fill: "white"
  })), _ellipse241 || (_ellipse241 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 537.339,
    cy: 123.172,
    rx: 0.851523,
    ry: 0.39327,
    fill: "white"
  })), _ellipse242 || (_ellipse242 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 665.074,
    cy: 123.172,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse243 || (_ellipse243 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 792.809,
    cy: 123.172,
    rx: 0.851476,
    ry: 0.39327,
    fill: "white"
  })), _ellipse244 || (_ellipse244 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 920.544,
    cy: 123.172,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse245 || (_ellipse245 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1048.28,
    cy: 123.172,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse246 || (_ellipse246 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1176.01,
    cy: 123.172,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse247 || (_ellipse247 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1303.75,
    cy: 123.172,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse248 || (_ellipse248 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.743,
    cy: 162.499,
    rx: 0.851576,
    ry: 0.39327,
    fill: "white"
  })), _ellipse249 || (_ellipse249 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.478,
    cy: 162.499,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse250 || (_ellipse250 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.213,
    cy: 162.499,
    rx: 0.851605,
    ry: 0.39327,
    fill: "white"
  })), _ellipse251 || (_ellipse251 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 596.949,
    cy: 162.499,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse252 || (_ellipse252 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 724.684,
    cy: 162.499,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse253 || (_ellipse253 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 852.418,
    cy: 162.499,
    rx: 0.85164,
    ry: 0.39327,
    fill: "white"
  })), _ellipse254 || (_ellipse254 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 980.154,
    cy: 162.499,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse255 || (_ellipse255 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1107.89,
    cy: 162.499,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse256 || (_ellipse256 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1235.62,
    cy: 162.499,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse257 || (_ellipse257 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1363.36,
    cy: 162.499,
    rx: 0.851874,
    ry: 0.39327,
    fill: "white"
  })), _ellipse258 || (_ellipse258 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.196,
    cy: 201.826,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse259 || (_ellipse259 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.931,
    cy: 201.826,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse260 || (_ellipse260 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.666,
    cy: 201.826,
    rx: 0.851535,
    ry: 0.39327,
    fill: "white"
  })), _ellipse261 || (_ellipse261 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 571.401,
    cy: 201.826,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse262 || (_ellipse262 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 699.137,
    cy: 201.826,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse263 || (_ellipse263 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 826.872,
    cy: 201.826,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse264 || (_ellipse264 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 954.607,
    cy: 201.826,
    rx: 0.8515,
    ry: 0.39327,
    fill: "white"
  })), _ellipse265 || (_ellipse265 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1082.34,
    cy: 201.826,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse266 || (_ellipse266 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1210.08,
    cy: 201.826,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse267 || (_ellipse267 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1337.81,
    cy: 201.826,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse268 || (_ellipse268 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.743,
    cy: 241.153,
    rx: 0.851576,
    ry: 0.39327,
    fill: "white"
  })), _ellipse269 || (_ellipse269 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.478,
    cy: 241.153,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse270 || (_ellipse270 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.213,
    cy: 241.153,
    rx: 0.851605,
    ry: 0.39327,
    fill: "white"
  })), _ellipse271 || (_ellipse271 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 596.949,
    cy: 241.153,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse272 || (_ellipse272 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 724.684,
    cy: 241.153,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse273 || (_ellipse273 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 852.418,
    cy: 241.153,
    rx: 0.85164,
    ry: 0.39327,
    fill: "white"
  })), _ellipse274 || (_ellipse274 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 980.154,
    cy: 241.153,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse275 || (_ellipse275 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1107.89,
    cy: 241.153,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse276 || (_ellipse276 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1235.62,
    cy: 241.153,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse277 || (_ellipse277 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1363.36,
    cy: 241.153,
    rx: 0.851874,
    ry: 0.39327,
    fill: "white"
  })), _ellipse278 || (_ellipse278 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.165,
    cy: 281.266,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse279 || (_ellipse279 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.9,
    cy: 281.266,
    rx: 0.851587,
    ry: 0.39327,
    fill: "white"
  })), _ellipse280 || (_ellipse280 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.635,
    cy: 281.266,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse281 || (_ellipse281 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 554.37,
    cy: 281.266,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse282 || (_ellipse282 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 682.105,
    cy: 281.266,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse283 || (_ellipse283 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 809.84,
    cy: 281.266,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse284 || (_ellipse284 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 937.575,
    cy: 281.266,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse285 || (_ellipse285 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1065.31,
    cy: 281.266,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse286 || (_ellipse286 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1193.05,
    cy: 281.266,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse287 || (_ellipse287 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1320.78,
    cy: 281.266,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse288 || (_ellipse288 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.259,
    cy: 320.592,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse289 || (_ellipse289 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 349.994,
    cy: 320.592,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse290 || (_ellipse290 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 477.729,
    cy: 320.592,
    rx: 0.851558,
    ry: 0.39327,
    fill: "white"
  })), _ellipse291 || (_ellipse291 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 605.464,
    cy: 320.592,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse292 || (_ellipse292 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 733.199,
    cy: 320.592,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse293 || (_ellipse293 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 860.934,
    cy: 320.592,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse294 || (_ellipse294 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 988.669,
    cy: 320.592,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse295 || (_ellipse295 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1116.4,
    cy: 320.592,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse296 || (_ellipse296 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1244.14,
    cy: 320.592,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse297 || (_ellipse297 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.228,
    cy: 359.919,
    rx: 0.851558,
    ry: 0.39327,
    fill: "white"
  })), _ellipse298 || (_ellipse298 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.963,
    cy: 359.919,
    rx: 0.851581,
    ry: 0.39327,
    fill: "white"
  })), _ellipse299 || (_ellipse299 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.698,
    cy: 359.919,
    rx: 0.851523,
    ry: 0.39327,
    fill: "white"
  })), _ellipse300 || (_ellipse300 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 588.433,
    cy: 359.919,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse301 || (_ellipse301 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 716.168,
    cy: 359.919,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse302 || (_ellipse302 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 843.903,
    cy: 359.919,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse303 || (_ellipse303 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 971.638,
    cy: 359.919,
    rx: 0.85164,
    ry: 0.39327,
    fill: "white"
  })), _ellipse304 || (_ellipse304 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1099.37,
    cy: 359.919,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse305 || (_ellipse305 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1227.11,
    cy: 359.919,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse306 || (_ellipse306 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1354.84,
    cy: 359.919,
    rx: 0.851406,
    ry: 0.39327,
    fill: "white"
  })), _ellipse307 || (_ellipse307 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.322,
    cy: 399.246,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse308 || (_ellipse308 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 384.057,
    cy: 399.246,
    rx: 0.851558,
    ry: 0.393259,
    fill: "white"
  })), _ellipse309 || (_ellipse309 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.792,
    cy: 399.246,
    rx: 0.851605,
    ry: 0.393259,
    fill: "white"
  })), _ellipse310 || (_ellipse310 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 639.527,
    cy: 399.246,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse311 || (_ellipse311 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 767.262,
    cy: 399.246,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse312 || (_ellipse312 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 894.997,
    cy: 399.246,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse313 || (_ellipse313 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1022.73,
    cy: 399.246,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse314 || (_ellipse314 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1150.47,
    cy: 399.246,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse315 || (_ellipse315 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1278.2,
    cy: 399.246,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse316 || (_ellipse316 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1405.94,
    cy: 398.459,
    rx: 0.851359,
    ry: 0.393259,
    fill: "white"
  })), _ellipse317 || (_ellipse317 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.196,
    cy: 438.574,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse318 || (_ellipse318 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.931,
    cy: 438.574,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse319 || (_ellipse319 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.666,
    cy: 438.574,
    rx: 0.851535,
    ry: 0.39328,
    fill: "white"
  })), _ellipse320 || (_ellipse320 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 571.401,
    cy: 438.574,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse321 || (_ellipse321 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 699.137,
    cy: 438.574,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse322 || (_ellipse322 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 826.872,
    cy: 438.574,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse323 || (_ellipse323 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 954.607,
    cy: 438.574,
    rx: 0.8515,
    ry: 0.39328,
    fill: "white"
  })), _ellipse324 || (_ellipse324 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1082.34,
    cy: 438.574,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse325 || (_ellipse325 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1210.08,
    cy: 438.574,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse326 || (_ellipse326 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1337.81,
    cy: 438.574,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse327 || (_ellipse327 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.743,
    cy: 477.9,
    rx: 0.851576,
    ry: 0.39328,
    fill: "white"
  })), _ellipse328 || (_ellipse328 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.478,
    cy: 477.9,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse329 || (_ellipse329 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.213,
    cy: 477.9,
    rx: 0.851605,
    ry: 0.39328,
    fill: "white"
  })), _ellipse330 || (_ellipse330 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 596.949,
    cy: 477.9,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse331 || (_ellipse331 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 724.684,
    cy: 477.9,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse332 || (_ellipse332 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 852.418,
    cy: 477.9,
    rx: 0.85164,
    ry: 0.39328,
    fill: "white"
  })), _ellipse333 || (_ellipse333 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 980.154,
    cy: 477.9,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse334 || (_ellipse334 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1107.89,
    cy: 477.9,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse335 || (_ellipse335 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1235.62,
    cy: 477.9,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse336 || (_ellipse336 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1363.36,
    cy: 477.9,
    rx: 0.851874,
    ry: 0.39328,
    fill: "white"
  })), _ellipse337 || (_ellipse337 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.353,
    cy: 521.159,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse338 || (_ellipse338 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 401.088,
    cy: 521.159,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse339 || (_ellipse339 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 528.823,
    cy: 521.159,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse340 || (_ellipse340 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.558,
    cy: 521.159,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse341 || (_ellipse341 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 784.293,
    cy: 521.159,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse342 || (_ellipse342 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.028,
    cy: 521.159,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse343 || (_ellipse343 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1039.76,
    cy: 521.159,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse344 || (_ellipse344 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1167.5,
    cy: 521.159,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse345 || (_ellipse345 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1295.23,
    cy: 521.159,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse346 || (_ellipse346 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1422.97,
    cy: 520.373,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse347 || (_ellipse347 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.259,
    cy: 564.419,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse348 || (_ellipse348 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 349.994,
    cy: 564.419,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse349 || (_ellipse349 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 477.729,
    cy: 564.419,
    rx: 0.851558,
    ry: 0.393259,
    fill: "white"
  })), _ellipse350 || (_ellipse350 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 605.464,
    cy: 564.419,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse351 || (_ellipse351 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 733.199,
    cy: 564.419,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse352 || (_ellipse352 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 860.934,
    cy: 564.419,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse353 || (_ellipse353 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 988.669,
    cy: 564.419,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse354 || (_ellipse354 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1116.4,
    cy: 564.419,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse355 || (_ellipse355 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1244.14,
    cy: 564.419,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse356 || (_ellipse356 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1371.87,
    cy: 564.419,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse357 || (_ellipse357 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.384,
    cy: 606.893,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse358 || (_ellipse358 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.119,
    cy: 606.893,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse359 || (_ellipse359 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 545.855,
    cy: 606.893,
    rx: 0.851617,
    ry: 0.393259,
    fill: "white"
  })), _ellipse360 || (_ellipse360 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 673.59,
    cy: 606.893,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse361 || (_ellipse361 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 801.325,
    cy: 606.893,
    rx: 0.851476,
    ry: 0.393259,
    fill: "white"
  })), _ellipse362 || (_ellipse362 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 929.06,
    cy: 606.893,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse363 || (_ellipse363 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1056.79,
    cy: 606.893,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse364 || (_ellipse364 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1184.53,
    cy: 606.893,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse365 || (_ellipse365 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1312.27,
    cy: 606.893,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse366 || (_ellipse366 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.29,
    cy: 650.152,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse367 || (_ellipse367 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.025,
    cy: 650.152,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse368 || (_ellipse368 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 494.76,
    cy: 650.152,
    rx: 0.851558,
    ry: 0.39328,
    fill: "white"
  })), _ellipse369 || (_ellipse369 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 622.496,
    cy: 650.152,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse370 || (_ellipse370 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 750.231,
    cy: 650.152,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse371 || (_ellipse371 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 877.966,
    cy: 650.152,
    rx: 0.851476,
    ry: 0.39328,
    fill: "white"
  })), _ellipse372 || (_ellipse372 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1005.7,
    cy: 650.152,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse373 || (_ellipse373 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1133.44,
    cy: 650.152,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse374 || (_ellipse374 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1261.17,
    cy: 650.152,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse375 || (_ellipse375 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1388.91,
    cy: 650.152,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse376 || (_ellipse376 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.196,
    cy: 693.411,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse377 || (_ellipse377 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.931,
    cy: 693.411,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse378 || (_ellipse378 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.666,
    cy: 693.411,
    rx: 0.851535,
    ry: 0.39328,
    fill: "white"
  })), _ellipse379 || (_ellipse379 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 571.401,
    cy: 693.411,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse380 || (_ellipse380 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 699.137,
    cy: 693.411,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse381 || (_ellipse381 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 826.872,
    cy: 693.411,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse382 || (_ellipse382 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 954.607,
    cy: 693.411,
    rx: 0.8515,
    ry: 0.39328,
    fill: "white"
  })), _ellipse383 || (_ellipse383 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1082.34,
    cy: 693.411,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse384 || (_ellipse384 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1210.08,
    cy: 693.411,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse385 || (_ellipse385 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1337.81,
    cy: 693.411,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse386 || (_ellipse386 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.29,
    cy: 736.671,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse387 || (_ellipse387 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.025,
    cy: 736.671,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse388 || (_ellipse388 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 494.76,
    cy: 736.671,
    rx: 0.851558,
    ry: 0.393259,
    fill: "white"
  })), _ellipse389 || (_ellipse389 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 622.496,
    cy: 736.671,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse390 || (_ellipse390 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 750.231,
    cy: 736.671,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse391 || (_ellipse391 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 877.966,
    cy: 736.671,
    rx: 0.851476,
    ry: 0.393259,
    fill: "white"
  })), _ellipse392 || (_ellipse392 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1005.7,
    cy: 736.671,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse393 || (_ellipse393 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1133.44,
    cy: 736.671,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse394 || (_ellipse394 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1261.17,
    cy: 736.671,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse395 || (_ellipse395 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.228,
    cy: 775.998,
    rx: 0.851558,
    ry: 0.393259,
    fill: "white"
  })), _ellipse396 || (_ellipse396 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.963,
    cy: 775.998,
    rx: 0.851581,
    ry: 0.393259,
    fill: "white"
  })), _ellipse397 || (_ellipse397 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.698,
    cy: 775.998,
    rx: 0.851523,
    ry: 0.393259,
    fill: "white"
  })), _ellipse398 || (_ellipse398 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 588.433,
    cy: 775.998,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse399 || (_ellipse399 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 716.168,
    cy: 775.998,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse400 || (_ellipse400 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 843.903,
    cy: 775.998,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse401 || (_ellipse401 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 971.638,
    cy: 775.998,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse402 || (_ellipse402 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1099.37,
    cy: 775.998,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse403 || (_ellipse403 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1227.11,
    cy: 775.998,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse404 || (_ellipse404 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1227.11,
    cy: 775.998,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse405 || (_ellipse405 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.353,
    cy: 815.326,
    rx: 0.85157,
    ry: 0.393302,
    fill: "white"
  })), _ellipse406 || (_ellipse406 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 401.088,
    cy: 815.326,
    rx: 0.85157,
    ry: 0.393302,
    fill: "white"
  })), _ellipse407 || (_ellipse407 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 528.823,
    cy: 815.326,
    rx: 0.851593,
    ry: 0.393302,
    fill: "white"
  })), _ellipse408 || (_ellipse408 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.558,
    cy: 815.326,
    rx: 0.85157,
    ry: 0.393302,
    fill: "white"
  })), _ellipse409 || (_ellipse409 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 784.293,
    cy: 815.326,
    rx: 0.85157,
    ry: 0.393302,
    fill: "white"
  })), _ellipse410 || (_ellipse410 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.028,
    cy: 815.326,
    rx: 0.851546,
    ry: 0.393302,
    fill: "white"
  })), _ellipse411 || (_ellipse411 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1039.76,
    cy: 815.326,
    rx: 0.851593,
    ry: 0.393302,
    fill: "white"
  })), _ellipse412 || (_ellipse412 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1167.5,
    cy: 815.326,
    rx: 0.851593,
    ry: 0.393302,
    fill: "white"
  })), _ellipse413 || (_ellipse413 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1295.23,
    cy: 815.326,
    rx: 0.851546,
    ry: 0.393302,
    fill: "white"
  })), _ellipse414 || (_ellipse414 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1388.91,
    cy: 736.671,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse415 || (_ellipse415 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.446,
    cy: 20.9216,
    rx: 0.851567,
    ry: 0.393269,
    fill: "white"
  })), _ellipse416 || (_ellipse416 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.181,
    cy: 20.9216,
    rx: 0.851564,
    ry: 0.393269,
    fill: "white"
  })), _ellipse417 || (_ellipse417 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 361.916,
    cy: 20.9216,
    rx: 0.851558,
    ry: 0.393269,
    fill: "white"
  })), _ellipse418 || (_ellipse418 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 489.651,
    cy: 20.9216,
    rx: 0.851605,
    ry: 0.393269,
    fill: "white"
  })), _ellipse419 || (_ellipse419 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.386,
    cy: 20.9216,
    rx: 0.851546,
    ry: 0.393269,
    fill: "white"
  })), _ellipse420 || (_ellipse420 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 745.121,
    cy: 20.9216,
    rx: 0.85157,
    ry: 0.393269,
    fill: "white"
  })), _ellipse421 || (_ellipse421 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.856,
    cy: 20.9216,
    rx: 0.85164,
    ry: 0.393269,
    fill: "white"
  })), _ellipse422 || (_ellipse422 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1000.59,
    cy: 20.9216,
    rx: 0.851593,
    ry: 0.393269,
    fill: "white"
  })), _ellipse423 || (_ellipse423 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1128.33,
    cy: 20.9216,
    rx: 0.851546,
    ry: 0.393269,
    fill: "white"
  })), _ellipse424 || (_ellipse424 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1256.06,
    cy: 20.9216,
    rx: 0.851546,
    ry: 0.393269,
    fill: "white"
  })), _ellipse425 || (_ellipse425 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.024,
    cy: 60.2478,
    rx: 0.851567,
    ry: 0.393267,
    fill: "white"
  })), _ellipse426 || (_ellipse426 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.759,
    cy: 60.2478,
    rx: 0.851546,
    ry: 0.393267,
    fill: "white"
  })), _ellipse427 || (_ellipse427 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 404.494,
    cy: 60.2478,
    rx: 0.85157,
    ry: 0.393267,
    fill: "white"
  })), _ellipse428 || (_ellipse428 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 532.229,
    cy: 60.2478,
    rx: 0.851617,
    ry: 0.393267,
    fill: "white"
  })), _ellipse429 || (_ellipse429 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 659.965,
    cy: 60.2478,
    rx: 0.85157,
    ry: 0.393267,
    fill: "white"
  })), _ellipse430 || (_ellipse430 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 787.7,
    cy: 60.2478,
    rx: 0.85157,
    ry: 0.393267,
    fill: "white"
  })), _ellipse431 || (_ellipse431 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 915.435,
    cy: 60.2478,
    rx: 0.851593,
    ry: 0.393267,
    fill: "white"
  })), _ellipse432 || (_ellipse432 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1043.17,
    cy: 60.2478,
    rx: 0.851546,
    ry: 0.393267,
    fill: "white"
  })), _ellipse433 || (_ellipse433 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1170.9,
    cy: 60.2478,
    rx: 0.851546,
    ry: 0.393267,
    fill: "white"
  })), _ellipse434 || (_ellipse434 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1298.64,
    cy: 60.2478,
    rx: 0.851593,
    ry: 0.393267,
    fill: "white"
  })), _ellipse435 || (_ellipse435 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.3832,
    cy: 99.5766,
    rx: 0.851571,
    ry: 0.39327,
    fill: "white"
  })), _ellipse436 || (_ellipse436 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.118,
    cy: 99.5766,
    rx: 0.851576,
    ry: 0.39327,
    fill: "white"
  })), _ellipse437 || (_ellipse437 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.853,
    cy: 99.5766,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse438 || (_ellipse438 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 455.588,
    cy: 99.5766,
    rx: 0.851617,
    ry: 0.39327,
    fill: "white"
  })), _ellipse439 || (_ellipse439 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 583.324,
    cy: 99.5766,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse440 || (_ellipse440 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 711.059,
    cy: 99.5766,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse441 || (_ellipse441 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 838.794,
    cy: 99.5766,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse442 || (_ellipse442 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 966.529,
    cy: 99.5766,
    rx: 0.85164,
    ry: 0.39327,
    fill: "white"
  })), _ellipse443 || (_ellipse443 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1094.26,
    cy: 99.5766,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse444 || (_ellipse444 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1222,
    cy: 99.5766,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse445 || (_ellipse445 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.8675,
    cy: 138.902,
    rx: 0.851567,
    ry: 0.39327,
    fill: "white"
  })), _ellipse446 || (_ellipse446 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.603,
    cy: 138.902,
    rx: 0.851567,
    ry: 0.39327,
    fill: "white"
  })), _ellipse447 || (_ellipse447 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.338,
    cy: 138.902,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse448 || (_ellipse448 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 447.073,
    cy: 138.902,
    rx: 0.851535,
    ry: 0.39327,
    fill: "white"
  })), _ellipse449 || (_ellipse449 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 574.808,
    cy: 138.902,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse450 || (_ellipse450 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 702.543,
    cy: 138.902,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse451 || (_ellipse451 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 830.278,
    cy: 138.902,
    rx: 0.85164,
    ry: 0.39327,
    fill: "white"
  })), _ellipse452 || (_ellipse452 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 958.013,
    cy: 138.902,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse453 || (_ellipse453 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1085.75,
    cy: 138.902,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse454 || (_ellipse454 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1213.48,
    cy: 138.902,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse455 || (_ellipse455 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.477,
    cy: 178.23,
    rx: 0.851567,
    ry: 0.39327,
    fill: "white"
  })), _ellipse456 || (_ellipse456 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.212,
    cy: 178.23,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse457 || (_ellipse457 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 378.947,
    cy: 178.23,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse458 || (_ellipse458 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 506.682,
    cy: 178.23,
    rx: 0.851535,
    ry: 0.39327,
    fill: "white"
  })), _ellipse459 || (_ellipse459 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 634.418,
    cy: 178.23,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse460 || (_ellipse460 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 762.153,
    cy: 178.23,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse461 || (_ellipse461 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 889.888,
    cy: 178.23,
    rx: 0.85164,
    ry: 0.39327,
    fill: "white"
  })), _ellipse462 || (_ellipse462 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1017.62,
    cy: 178.23,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse463 || (_ellipse463 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1145.36,
    cy: 178.23,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse464 || (_ellipse464 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1273.09,
    cy: 178.23,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse465 || (_ellipse465 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.9302,
    cy: 217.556,
    rx: 0.851568,
    ry: 0.39327,
    fill: "white"
  })), _ellipse466 || (_ellipse466 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.665,
    cy: 217.556,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse467 || (_ellipse467 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 353.4,
    cy: 217.556,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse468 || (_ellipse468 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 481.135,
    cy: 217.556,
    rx: 0.851558,
    ry: 0.39327,
    fill: "white"
  })), _ellipse469 || (_ellipse469 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 608.87,
    cy: 217.556,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse470 || (_ellipse470 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 736.606,
    cy: 217.556,
    rx: 0.85164,
    ry: 0.39327,
    fill: "white"
  })), _ellipse471 || (_ellipse471 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 864.341,
    cy: 217.556,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse472 || (_ellipse472 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 992.076,
    cy: 217.556,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse473 || (_ellipse473 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1119.81,
    cy: 217.556,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse474 || (_ellipse474 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1247.55,
    cy: 217.556,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse475 || (_ellipse475 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.477,
    cy: 256.883,
    rx: 0.851567,
    ry: 0.39327,
    fill: "white"
  })), _ellipse476 || (_ellipse476 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.212,
    cy: 256.883,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse477 || (_ellipse477 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 378.947,
    cy: 256.883,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse478 || (_ellipse478 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 506.682,
    cy: 256.883,
    rx: 0.851535,
    ry: 0.39327,
    fill: "white"
  })), _ellipse479 || (_ellipse479 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 634.418,
    cy: 256.883,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse480 || (_ellipse480 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 762.153,
    cy: 256.883,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse481 || (_ellipse481 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 889.888,
    cy: 256.883,
    rx: 0.85164,
    ry: 0.39327,
    fill: "white"
  })), _ellipse482 || (_ellipse482 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1017.62,
    cy: 256.883,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse483 || (_ellipse483 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1145.36,
    cy: 256.883,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse484 || (_ellipse484 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1273.09,
    cy: 256.883,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse485 || (_ellipse485 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.8989,
    cy: 296.997,
    rx: 0.851567,
    ry: 0.39327,
    fill: "white"
  })), _ellipse486 || (_ellipse486 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.634,
    cy: 296.997,
    rx: 0.851555,
    ry: 0.39327,
    fill: "white"
  })), _ellipse487 || (_ellipse487 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.369,
    cy: 296.997,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse488 || (_ellipse488 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 464.104,
    cy: 296.997,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse489 || (_ellipse489 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 591.839,
    cy: 296.997,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse490 || (_ellipse490 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 719.574,
    cy: 296.997,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse491 || (_ellipse491 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 847.309,
    cy: 296.997,
    rx: 0.851476,
    ry: 0.39327,
    fill: "white"
  })), _ellipse492 || (_ellipse492 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 975.044,
    cy: 296.997,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse493 || (_ellipse493 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1102.78,
    cy: 296.997,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse494 || (_ellipse494 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1230.51,
    cy: 296.997,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse495 || (_ellipse495 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.993,
    cy: 336.322,
    rx: 0.851567,
    ry: 0.39327,
    fill: "white"
  })), _ellipse496 || (_ellipse496 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.728,
    cy: 336.322,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse497 || (_ellipse497 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.463,
    cy: 336.322,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse498 || (_ellipse498 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 515.198,
    cy: 336.322,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse499 || (_ellipse499 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 642.933,
    cy: 336.322,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse500 || (_ellipse500 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 770.668,
    cy: 336.322,
    rx: 0.851476,
    ry: 0.39327,
    fill: "white"
  })), _ellipse501 || (_ellipse501 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 898.403,
    cy: 336.322,
    rx: 0.85157,
    ry: 0.39327,
    fill: "white"
  })), _ellipse502 || (_ellipse502 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1026.14,
    cy: 336.322,
    rx: 0.851546,
    ry: 0.39327,
    fill: "white"
  })), _ellipse503 || (_ellipse503 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1153.87,
    cy: 336.322,
    rx: 0.851593,
    ry: 0.39327,
    fill: "white"
  })), _ellipse504 || (_ellipse504 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.962,
    cy: 375.65,
    rx: 0.851568,
    ry: 0.393259,
    fill: "white"
  })), _ellipse505 || (_ellipse505 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.697,
    cy: 375.65,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse506 || (_ellipse506 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370.432,
    cy: 375.65,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse507 || (_ellipse507 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 498.167,
    cy: 375.65,
    rx: 0.851535,
    ry: 0.393259,
    fill: "white"
  })), _ellipse508 || (_ellipse508 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 625.902,
    cy: 375.65,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse509 || (_ellipse509 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 753.637,
    cy: 375.65,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse510 || (_ellipse510 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 881.372,
    cy: 375.65,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse511 || (_ellipse511 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1009.11,
    cy: 375.65,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse512 || (_ellipse512 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1136.84,
    cy: 375.65,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse513 || (_ellipse513 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1264.58,
    cy: 375.65,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse514 || (_ellipse514 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.055,
    cy: 414.976,
    rx: 0.851568,
    ry: 0.39328,
    fill: "white"
  })), _ellipse515 || (_ellipse515 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.791,
    cy: 414.976,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse516 || (_ellipse516 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.526,
    cy: 414.976,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse517 || (_ellipse517 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 549.261,
    cy: 414.976,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse518 || (_ellipse518 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 676.996,
    cy: 414.976,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse519 || (_ellipse519 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 804.731,
    cy: 414.976,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse520 || (_ellipse520 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 932.466,
    cy: 414.976,
    rx: 0.851453,
    ry: 0.39328,
    fill: "white"
  })), _ellipse521 || (_ellipse521 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1060.2,
    cy: 414.976,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse522 || (_ellipse522 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1187.94,
    cy: 414.976,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse523 || (_ellipse523 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1315.67,
    cy: 414.976,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse524 || (_ellipse524 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.9302,
    cy: 454.304,
    rx: 0.851568,
    ry: 0.393259,
    fill: "white"
  })), _ellipse525 || (_ellipse525 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.665,
    cy: 454.304,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse526 || (_ellipse526 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 353.4,
    cy: 454.304,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse527 || (_ellipse527 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 481.135,
    cy: 454.304,
    rx: 0.851558,
    ry: 0.393259,
    fill: "white"
  })), _ellipse528 || (_ellipse528 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 608.87,
    cy: 454.304,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse529 || (_ellipse529 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 736.606,
    cy: 454.304,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse530 || (_ellipse530 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 864.341,
    cy: 454.304,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse531 || (_ellipse531 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 992.076,
    cy: 454.304,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse532 || (_ellipse532 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1119.81,
    cy: 454.304,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse533 || (_ellipse533 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1247.55,
    cy: 454.304,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse534 || (_ellipse534 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.477,
    cy: 493.63,
    rx: 0.851567,
    ry: 0.39328,
    fill: "white"
  })), _ellipse535 || (_ellipse535 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.212,
    cy: 493.63,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse536 || (_ellipse536 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 378.947,
    cy: 493.63,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse537 || (_ellipse537 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 506.682,
    cy: 493.63,
    rx: 0.851535,
    ry: 0.39328,
    fill: "white"
  })), _ellipse538 || (_ellipse538 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 634.418,
    cy: 493.63,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse539 || (_ellipse539 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 762.153,
    cy: 493.63,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse540 || (_ellipse540 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 889.888,
    cy: 493.63,
    rx: 0.85164,
    ry: 0.39328,
    fill: "white"
  })), _ellipse541 || (_ellipse541 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1017.62,
    cy: 493.63,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse542 || (_ellipse542 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1145.36,
    cy: 493.63,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse543 || (_ellipse543 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1273.09,
    cy: 493.63,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse544 || (_ellipse544 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.087,
    cy: 536.89,
    rx: 0.851567,
    ry: 0.393259,
    fill: "white"
  })), _ellipse545 || (_ellipse545 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.822,
    cy: 536.89,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse546 || (_ellipse546 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.557,
    cy: 536.89,
    rx: 0.851581,
    ry: 0.393259,
    fill: "white"
  })), _ellipse547 || (_ellipse547 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.292,
    cy: 536.89,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse548 || (_ellipse548 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 694.027,
    cy: 536.89,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse549 || (_ellipse549 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 821.762,
    cy: 536.89,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse550 || (_ellipse550 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 949.497,
    cy: 536.89,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse551 || (_ellipse551 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1077.23,
    cy: 536.89,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse552 || (_ellipse552 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1204.97,
    cy: 536.89,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse553 || (_ellipse553 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1332.7,
    cy: 536.89,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse554 || (_ellipse554 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.993,
    cy: 580.149,
    rx: 0.851567,
    ry: 0.39328,
    fill: "white"
  })), _ellipse555 || (_ellipse555 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.728,
    cy: 580.149,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse556 || (_ellipse556 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.463,
    cy: 580.149,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse557 || (_ellipse557 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 515.198,
    cy: 580.149,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse558 || (_ellipse558 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 642.933,
    cy: 580.149,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse559 || (_ellipse559 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 770.668,
    cy: 580.149,
    rx: 0.851476,
    ry: 0.39328,
    fill: "white"
  })), _ellipse560 || (_ellipse560 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 898.403,
    cy: 580.149,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse561 || (_ellipse561 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1026.14,
    cy: 580.149,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse562 || (_ellipse562 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1153.87,
    cy: 580.149,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse563 || (_ellipse563 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1281.61,
    cy: 580.149,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse564 || (_ellipse564 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.118,
    cy: 622.623,
    rx: 0.851576,
    ry: 0.393237,
    fill: "white"
  })), _ellipse565 || (_ellipse565 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.853,
    cy: 622.623,
    rx: 0.851546,
    ry: 0.393237,
    fill: "white"
  })), _ellipse566 || (_ellipse566 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 455.588,
    cy: 622.623,
    rx: 0.851617,
    ry: 0.393237,
    fill: "white"
  })), _ellipse567 || (_ellipse567 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 583.324,
    cy: 622.623,
    rx: 0.85157,
    ry: 0.393237,
    fill: "white"
  })), _ellipse568 || (_ellipse568 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 711.059,
    cy: 622.623,
    rx: 0.851546,
    ry: 0.393237,
    fill: "white"
  })), _ellipse569 || (_ellipse569 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 838.794,
    cy: 622.623,
    rx: 0.851593,
    ry: 0.393237,
    fill: "white"
  })), _ellipse570 || (_ellipse570 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 966.529,
    cy: 622.623,
    rx: 0.85164,
    ry: 0.393237,
    fill: "white"
  })), _ellipse571 || (_ellipse571 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1094.26,
    cy: 622.623,
    rx: 0.851546,
    ry: 0.393237,
    fill: "white"
  })), _ellipse572 || (_ellipse572 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1222,
    cy: 622.623,
    rx: 0.851593,
    ry: 0.393237,
    fill: "white"
  })), _ellipse573 || (_ellipse573 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.024,
    cy: 665.882,
    rx: 0.851567,
    ry: 0.39328,
    fill: "white"
  })), _ellipse574 || (_ellipse574 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.759,
    cy: 665.882,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse575 || (_ellipse575 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 404.494,
    cy: 665.882,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse576 || (_ellipse576 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 532.229,
    cy: 665.882,
    rx: 0.851617,
    ry: 0.39328,
    fill: "white"
  })), _ellipse577 || (_ellipse577 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 659.965,
    cy: 665.882,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse578 || (_ellipse578 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 787.7,
    cy: 665.882,
    rx: 0.85157,
    ry: 0.39328,
    fill: "white"
  })), _ellipse579 || (_ellipse579 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 915.435,
    cy: 665.882,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse580 || (_ellipse580 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1043.17,
    cy: 665.882,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse581 || (_ellipse581 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1170.9,
    cy: 665.882,
    rx: 0.851546,
    ry: 0.39328,
    fill: "white"
  })), _ellipse582 || (_ellipse582 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1298.64,
    cy: 665.882,
    rx: 0.851593,
    ry: 0.39328,
    fill: "white"
  })), _ellipse583 || (_ellipse583 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.9302,
    cy: 709.142,
    rx: 0.851568,
    ry: 0.393259,
    fill: "white"
  })), _ellipse584 || (_ellipse584 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.665,
    cy: 709.142,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse585 || (_ellipse585 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 353.4,
    cy: 709.142,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse586 || (_ellipse586 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 481.135,
    cy: 709.142,
    rx: 0.851558,
    ry: 0.393259,
    fill: "white"
  })), _ellipse587 || (_ellipse587 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 608.87,
    cy: 709.142,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse588 || (_ellipse588 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 736.606,
    cy: 709.142,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse589 || (_ellipse589 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 864.341,
    cy: 709.142,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse590 || (_ellipse590 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 992.076,
    cy: 709.142,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse591 || (_ellipse591 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1119.81,
    cy: 709.142,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse592 || (_ellipse592 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1247.55,
    cy: 709.142,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse593 || (_ellipse593 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.024,
    cy: 752.402,
    rx: 0.851567,
    ry: 0.393216,
    fill: "white"
  })), _ellipse594 || (_ellipse594 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.759,
    cy: 752.402,
    rx: 0.851546,
    ry: 0.393216,
    fill: "white"
  })), _ellipse595 || (_ellipse595 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 404.494,
    cy: 752.402,
    rx: 0.85157,
    ry: 0.393216,
    fill: "white"
  })), _ellipse596 || (_ellipse596 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 532.229,
    cy: 752.402,
    rx: 0.851617,
    ry: 0.393216,
    fill: "white"
  })), _ellipse597 || (_ellipse597 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 659.965,
    cy: 752.402,
    rx: 0.85157,
    ry: 0.393216,
    fill: "white"
  })), _ellipse598 || (_ellipse598 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 787.7,
    cy: 752.402,
    rx: 0.85157,
    ry: 0.393216,
    fill: "white"
  })), _ellipse599 || (_ellipse599 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 915.435,
    cy: 752.402,
    rx: 0.851593,
    ry: 0.393216,
    fill: "white"
  })), _ellipse600 || (_ellipse600 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1043.17,
    cy: 752.402,
    rx: 0.851546,
    ry: 0.393216,
    fill: "white"
  })), _ellipse601 || (_ellipse601 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1170.9,
    cy: 752.402,
    rx: 0.851546,
    ry: 0.393216,
    fill: "white"
  })), _ellipse602 || (_ellipse602 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.962,
    cy: 791.728,
    rx: 0.851568,
    ry: 0.393259,
    fill: "white"
  })), _ellipse603 || (_ellipse603 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.697,
    cy: 791.728,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse604 || (_ellipse604 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370.432,
    cy: 791.728,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse605 || (_ellipse605 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 498.167,
    cy: 791.728,
    rx: 0.851535,
    ry: 0.393259,
    fill: "white"
  })), _ellipse606 || (_ellipse606 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 625.902,
    cy: 791.728,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse607 || (_ellipse607 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 753.637,
    cy: 791.728,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse608 || (_ellipse608 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 881.372,
    cy: 791.728,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse609 || (_ellipse609 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1009.11,
    cy: 791.728,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse610 || (_ellipse610 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1136.84,
    cy: 791.728,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse611 || (_ellipse611 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1136.84,
    cy: 791.728,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse612 || (_ellipse612 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.087,
    cy: 831.056,
    rx: 0.851567,
    ry: 0.393302,
    fill: "white"
  })), _ellipse613 || (_ellipse613 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.822,
    cy: 831.056,
    rx: 0.851546,
    ry: 0.393302,
    fill: "white"
  })), _ellipse614 || (_ellipse614 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.557,
    cy: 831.056,
    rx: 0.851581,
    ry: 0.393302,
    fill: "white"
  })), _ellipse615 || (_ellipse615 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.292,
    cy: 831.056,
    rx: 0.85157,
    ry: 0.393302,
    fill: "white"
  })), _ellipse616 || (_ellipse616 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 694.027,
    cy: 831.056,
    rx: 0.851546,
    ry: 0.393302,
    fill: "white"
  })), _ellipse617 || (_ellipse617 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 821.762,
    cy: 831.056,
    rx: 0.85157,
    ry: 0.393302,
    fill: "white"
  })), _ellipse618 || (_ellipse618 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 949.497,
    cy: 831.056,
    rx: 0.85164,
    ry: 0.393302,
    fill: "white"
  })), _ellipse619 || (_ellipse619 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1077.23,
    cy: 831.056,
    rx: 0.851593,
    ry: 0.393302,
    fill: "white"
  })), _ellipse620 || (_ellipse620 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1204.97,
    cy: 831.056,
    rx: 0.851546,
    ry: 0.393302,
    fill: "white"
  })), _ellipse621 || (_ellipse621 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1298.64,
    cy: 752.402,
    rx: 0.851593,
    ry: 0.393216,
    fill: "white"
  })), _ellipse622 || (_ellipse622 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.6955,
    cy: 60.6408,
    rx: 1.70313,
    ry: 0.786537,
    fill: "white"
  })), _ellipse623 || (_ellipse623 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.166,
    cy: 64.5756,
    rx: 1.70315,
    ry: 0.786537,
    fill: "white"
  })), _ellipse624 || (_ellipse624 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 535.636,
    cy: 60.6408,
    rx: 1.70314,
    ry: 0.786537,
    fill: "white"
  })), _ellipse625 || (_ellipse625 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 791.106,
    cy: 56.7091,
    rx: 1.70312,
    ry: 0.786539,
    fill: "white"
  })), _ellipse626 || (_ellipse626 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1046.58,
    cy: 60.6408,
    rx: 1.70314,
    ry: 0.786537,
    fill: "white"
  })), _ellipse627 || (_ellipse627 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1302.05,
    cy: 64.5756,
    rx: 1.70314,
    ry: 0.786537,
    fill: "white"
  })), _ellipse628 || (_ellipse628 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.758,
    cy: 139.295,
    rx: 1.70313,
    ry: 0.786534,
    fill: "white"
  })), _ellipse629 || (_ellipse629 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.228,
    cy: 143.229,
    rx: 1.70312,
    ry: 0.786534,
    fill: "white"
  })), _ellipse630 || (_ellipse630 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 569.698,
    cy: 139.295,
    rx: 1.70312,
    ry: 0.786534,
    fill: "white"
  })), _ellipse631 || (_ellipse631 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 825.169,
    cy: 135.363,
    rx: 1.70312,
    ry: 0.786539,
    fill: "white"
  })), _ellipse632 || (_ellipse632 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1080.64,
    cy: 139.295,
    rx: 1.70314,
    ry: 0.786534,
    fill: "white"
  })), _ellipse633 || (_ellipse633 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1336.11,
    cy: 143.229,
    rx: 1.70319,
    ry: 0.786534,
    fill: "white"
  })), _ellipse634 || (_ellipse634 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.66413,
    cy: 217.949,
    rx: 1.70313,
    ry: 0.786539,
    fill: "white"
  })), _ellipse635 || (_ellipse635 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.134,
    cy: 221.883,
    rx: 1.70313,
    ry: 0.78655,
    fill: "white"
  })), _ellipse636 || (_ellipse636 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 518.604,
    cy: 217.949,
    rx: 1.70314,
    ry: 0.786539,
    fill: "white"
  })), _ellipse637 || (_ellipse637 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 774.075,
    cy: 214.017,
    rx: 1.70321,
    ry: 0.786539,
    fill: "white"
  })), _ellipse638 || (_ellipse638 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1029.54,
    cy: 217.949,
    rx: 1.70319,
    ry: 0.786539,
    fill: "white"
  })), _ellipse639 || (_ellipse639 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1285.02,
    cy: 221.883,
    rx: 1.70309,
    ry: 0.78655,
    fill: "white"
  })), _ellipse640 || (_ellipse640 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.852,
    cy: 297.39,
    rx: 1.70313,
    ry: 0.786539,
    fill: "white"
  })), _ellipse641 || (_ellipse641 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 365.322,
    cy: 301.322,
    rx: 1.70313,
    ry: 0.786529,
    fill: "white"
  })), _ellipse642 || (_ellipse642 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 620.793,
    cy: 297.39,
    rx: 1.70314,
    ry: 0.786539,
    fill: "white"
  })), _ellipse643 || (_ellipse643 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 876.263,
    cy: 293.456,
    rx: 1.70316,
    ry: 0.786539,
    fill: "white"
  })), _ellipse644 || (_ellipse644 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1131.73,
    cy: 297.39,
    rx: 1.70309,
    ry: 0.786539,
    fill: "white"
  })), _ellipse645 || (_ellipse645 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1387.2,
    cy: 300.536,
    rx: 1.70314,
    ry: 0.786539,
    fill: "white"
  })), _ellipse646 || (_ellipse646 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.2739,
    cy: 376.042,
    rx: 1.70313,
    ry: 0.786518,
    fill: "white"
  })), _ellipse647 || (_ellipse647 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.744,
    cy: 379.975,
    rx: 1.70313,
    ry: 0.786539,
    fill: "white"
  })), _ellipse648 || (_ellipse648 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 578.214,
    cy: 376.042,
    rx: 1.70312,
    ry: 0.786518,
    fill: "white"
  })), _ellipse649 || (_ellipse649 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 833.684,
    cy: 372.11,
    rx: 1.70321,
    ry: 0.786539,
    fill: "white"
  })), _ellipse650 || (_ellipse650 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1089.15,
    cy: 376.042,
    rx: 1.70314,
    ry: 0.786518,
    fill: "white"
  })), _ellipse651 || (_ellipse651 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1344.62,
    cy: 379.975,
    rx: 1.70314,
    ry: 0.786539,
    fill: "white"
  })), _ellipse652 || (_ellipse652 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.6955,
    cy: 453.91,
    rx: 1.70313,
    ry: 0.786539,
    fill: "white"
  })), _ellipse653 || (_ellipse653 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.166,
    cy: 458.63,
    rx: 1.70315,
    ry: 0.786539,
    fill: "white"
  })), _ellipse654 || (_ellipse654 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 535.636,
    cy: 454.697,
    rx: 1.70314,
    ry: 0.786539,
    fill: "white"
  })), _ellipse655 || (_ellipse655 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 791.106,
    cy: 450.763,
    rx: 1.70312,
    ry: 0.786539,
    fill: "white"
  })), _ellipse656 || (_ellipse656 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1046.58,
    cy: 454.697,
    rx: 1.70314,
    ry: 0.786539,
    fill: "white"
  })), _ellipse657 || (_ellipse657 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1302.05,
    cy: 458.63,
    rx: 1.70314,
    ry: 0.786539,
    fill: "white"
  })), _ellipse658 || (_ellipse658 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.946,
    cy: 533.351,
    rx: 1.70313,
    ry: 0.786518,
    fill: "white"
  })), _ellipse659 || (_ellipse659 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 416.416,
    cy: 537.284,
    rx: 1.70314,
    ry: 0.786539,
    fill: "white"
  })), _ellipse660 || (_ellipse660 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 671.886,
    cy: 533.351,
    rx: 1.70314,
    ry: 0.786518,
    fill: "white"
  })), _ellipse661 || (_ellipse661 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 927.357,
    cy: 529.417,
    rx: 1.70323,
    ry: 0.786539,
    fill: "white"
  })), _ellipse662 || (_ellipse662 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1182.83,
    cy: 533.351,
    rx: 1.70319,
    ry: 0.786518,
    fill: "white"
  })), _ellipse663 || (_ellipse663 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1438.3,
    cy: 536.497,
    rx: 1.70314,
    ry: 0.786539,
    fill: "white"
  })), _ellipse664 || (_ellipse664 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70313,
    cy: 611.218,
    rx: 1.70313,
    ry: 0.786539,
    fill: "white"
  })), _ellipse665 || (_ellipse665 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.173,
    cy: 615.151,
    rx: 1.70313,
    ry: 0.786539,
    fill: "white"
  })), _ellipse666 || (_ellipse666 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 512.643,
    cy: 611.218,
    rx: 1.70316,
    ry: 0.786539,
    fill: "white"
  })), _ellipse667 || (_ellipse667 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 768.114,
    cy: 607.284,
    rx: 1.70321,
    ry: 0.786539,
    fill: "white"
  })), _ellipse668 || (_ellipse668 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1023.58,
    cy: 611.218,
    rx: 1.70314,
    ry: 0.786539,
    fill: "white"
  })), _ellipse669 || (_ellipse669 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1279.05,
    cy: 615.151,
    rx: 1.70314,
    ry: 0.786539,
    fill: "white"
  })), _ellipse670 || (_ellipse670 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.2893,
    cy: 679.646,
    rx: 1.70314,
    ry: 0.786518,
    fill: "white"
  })), _ellipse671 || (_ellipse671 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.759,
    cy: 683.579,
    rx: 1.70312,
    ry: 0.786539,
    fill: "white"
  })), _ellipse672 || (_ellipse672 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 532.229,
    cy: 679.646,
    rx: 1.70312,
    ry: 0.786518,
    fill: "white"
  })), _ellipse673 || (_ellipse673 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 787.7,
    cy: 675.713,
    rx: 1.70321,
    ry: 0.786561,
    fill: "white"
  })), _ellipse674 || (_ellipse674 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1043.17,
    cy: 679.646,
    rx: 1.70314,
    ry: 0.786518,
    fill: "white"
  })), _ellipse675 || (_ellipse675 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1298.64,
    cy: 683.579,
    rx: 1.70314,
    ry: 0.786539,
    fill: "white"
  })), _ellipse676 || (_ellipse676 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.4536,
    cy: 763.805,
    rx: 1.70313,
    ry: 0.786518,
    fill: "white"
  })), _ellipse677 || (_ellipse677 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 338.924,
    cy: 767.739,
    rx: 1.70313,
    ry: 0.786518,
    fill: "white"
  })), _ellipse678 || (_ellipse678 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 594.394,
    cy: 763.805,
    rx: 1.70314,
    ry: 0.786518,
    fill: "white"
  })), _ellipse679 || (_ellipse679 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 849.864,
    cy: 759.873,
    rx: 1.70307,
    ry: 0.786518,
    fill: "white"
  })), _ellipse680 || (_ellipse680 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1105.33,
    cy: 763.805,
    rx: 1.70314,
    ry: 0.786518,
    fill: "white"
  })), _ellipse681 || (_ellipse681 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1319.93,
    cy: 837.425,
    rx: 1.70314,
    ry: 0.786518,
    fill: "white"
  })), _ellipse682 || (_ellipse682 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.993,
    cy: 841.438,
    rx: 0.851567,
    ry: 0.393259,
    fill: "white"
  })), _ellipse683 || (_ellipse683 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.728,
    cy: 841.438,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse684 || (_ellipse684 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.464,
    cy: 841.438,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse685 || (_ellipse685 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 515.198,
    cy: 841.438,
    rx: 0.851617,
    ry: 0.393259,
    fill: "white"
  })), _ellipse686 || (_ellipse686 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 642.933,
    cy: 841.438,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse687 || (_ellipse687 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 770.669,
    cy: 841.438,
    rx: 0.851476,
    ry: 0.393259,
    fill: "white"
  })), _ellipse688 || (_ellipse688 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 898.404,
    cy: 841.438,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse689 || (_ellipse689 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1026.14,
    cy: 841.438,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse690 || (_ellipse690 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1153.87,
    cy: 841.438,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse691 || (_ellipse691 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1153.87,
    cy: 841.438,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse692 || (_ellipse692 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.572,
    cy: 845.369,
    rx: 0.851558,
    ry: 0.393259,
    fill: "white"
  })), _ellipse693 || (_ellipse693 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.307,
    cy: 845.369,
    rx: 0.851581,
    ry: 0.393259,
    fill: "white"
  })), _ellipse694 || (_ellipse694 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 430.041,
    cy: 845.369,
    rx: 0.851523,
    ry: 0.393259,
    fill: "white"
  })), _ellipse695 || (_ellipse695 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 557.776,
    cy: 845.369,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse696 || (_ellipse696 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 685.512,
    cy: 845.369,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse697 || (_ellipse697 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 813.247,
    cy: 845.369,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse698 || (_ellipse698 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 940.981,
    cy: 845.369,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse699 || (_ellipse699 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1068.72,
    cy: 845.369,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse700 || (_ellipse700 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1196.45,
    cy: 845.369,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse701 || (_ellipse701 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1196.45,
    cy: 845.369,
    rx: 0.851593,
    ry: 0.393259,
    fill: "white"
  })), _ellipse702 || (_ellipse702 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.368,
    cy: 821.774,
    rx: 0.851567,
    ry: 0.393216,
    fill: "white"
  })), _ellipse703 || (_ellipse703 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 246.103,
    cy: 821.774,
    rx: 0.851546,
    ry: 0.393216,
    fill: "white"
  })), _ellipse704 || (_ellipse704 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.837,
    cy: 821.774,
    rx: 0.85157,
    ry: 0.393216,
    fill: "white"
  })), _ellipse705 || (_ellipse705 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 501.572,
    cy: 821.774,
    rx: 0.851617,
    ry: 0.393216,
    fill: "white"
  })), _ellipse706 || (_ellipse706 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 629.308,
    cy: 821.774,
    rx: 0.85157,
    ry: 0.393216,
    fill: "white"
  })), _ellipse707 || (_ellipse707 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 757.043,
    cy: 821.774,
    rx: 0.85157,
    ry: 0.393216,
    fill: "white"
  })), _ellipse708 || (_ellipse708 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 884.777,
    cy: 821.774,
    rx: 0.851593,
    ry: 0.393216,
    fill: "white"
  })), _ellipse709 || (_ellipse709 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1012.51,
    cy: 821.774,
    rx: 0.851546,
    ry: 0.393216,
    fill: "white"
  })), _ellipse710 || (_ellipse710 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1140.25,
    cy: 821.774,
    rx: 0.851546,
    ry: 0.393216,
    fill: "white"
  })), _ellipse711 || (_ellipse711 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.04,
    cy: 861.1,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse712 || (_ellipse712 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 339.776,
    cy: 861.1,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse713 || (_ellipse713 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 467.51,
    cy: 861.1,
    rx: 0.851535,
    ry: 0.393259,
    fill: "white"
  })), _ellipse714 || (_ellipse714 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 595.245,
    cy: 861.1,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse715 || (_ellipse715 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 722.979,
    cy: 861.1,
    rx: 0.85164,
    ry: 0.393259,
    fill: "white"
  })), _ellipse716 || (_ellipse716 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 850.715,
    cy: 861.1,
    rx: 0.85157,
    ry: 0.393259,
    fill: "white"
  })), _ellipse717 || (_ellipse717 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 978.45,
    cy: 861.1,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse718 || (_ellipse718 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1106.19,
    cy: 861.1,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse719 || (_ellipse719 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1106.19,
    cy: 861.1,
    rx: 0.851546,
    ry: 0.393259,
    fill: "white"
  })), _ellipse720 || (_ellipse720 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1267.98,
    cy: 821.774,
    rx: 0.851593,
    ry: 0.393216,
    fill: "white"
  })), _ellipse721 || (_ellipse721 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.267,
    cy: 837.111,
    rx: 1.70313,
    ry: 0.786518,
    fill: "white"
  })), _ellipse722 || (_ellipse722 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 563.738,
    cy: 833.178,
    rx: 1.70314,
    ry: 0.786518,
    fill: "white"
  })), _ellipse723 || (_ellipse723 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 819.207,
    cy: 829.245,
    rx: 1.70307,
    ry: 0.786518,
    fill: "white"
  })), _ellipse724 || (_ellipse724 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.68,
    cy: 833.178,
    rx: 1.70314,
    ry: 0.786518,
    fill: "white"
  })), _ellipse725 || (_ellipse725 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1360.8,
    cy: 767.739,
    rx: 1.703,
    ry: 0.786518,
    fill: "white"
  })), _ellipse726 || (_ellipse726 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.3985,
    cy: 847.965,
    rx: 1.70315,
    ry: 0.786561,
    fill: "white"
  })), _ellipse727 || (_ellipse727 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.869,
    cy: 851.898,
    rx: 1.70313,
    ry: 0.786475,
    fill: "white"
  })), _ellipse728 || (_ellipse728 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 537.339,
    cy: 847.965,
    rx: 1.70309,
    ry: 0.786561,
    fill: "white"
  })), _ellipse729 || (_ellipse729 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 792.809,
    cy: 844.032,
    rx: 1.70323,
    ry: 0.786561,
    fill: "white"
  })), _ellipse730 || (_ellipse730 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1048.28,
    cy: 847.965,
    rx: 1.70309,
    ry: 0.786561,
    fill: "white"
  })), _ellipse731 || (_ellipse731 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1303.75,
    cy: 851.898,
    rx: 1.70314,
    ry: 0.786475,
    fill: "white"
  })), _ellipse732 || (_ellipse732 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851564,
    cy: 0.393259,
    rx: 0.851564,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 1222.85 876.123)",
    fill: "white"
  })), _ellipse733 || (_ellipse733 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393259,
    rx: 0.85157,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 1095.12 876.123)",
    fill: "white"
  })), _ellipse734 || (_ellipse734 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851558,
    cy: 0.393259,
    rx: 0.851558,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 967.381 876.123)",
    fill: "white"
  })), _ellipse735 || (_ellipse735 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393259,
    rx: 0.85157,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 839.647 876.123)",
    fill: "white"
  })), _ellipse736 || (_ellipse736 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85164,
    cy: 0.393259,
    rx: 0.85164,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 711.911 876.123)",
    fill: "white"
  })), _ellipse737 || (_ellipse737 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851476,
    cy: 0.393259,
    rx: 0.851476,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 584.176 876.123)",
    fill: "white"
  })), _ellipse738 || (_ellipse738 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851593,
    cy: 0.393259,
    rx: 0.851593,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 456.44 876.123)",
    fill: "white"
  })), _ellipse739 || (_ellipse739 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393259,
    rx: 0.851546,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 328.707 876.123)",
    fill: "white"
  })), _ellipse740 || (_ellipse740 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393259,
    rx: 0.851546,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 200.971 876.123)",
    fill: "white"
  })), _ellipse741 || (_ellipse741 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393302,
    rx: 0.85157,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 1180.27 880.056)",
    fill: "white"
  })), _ellipse742 || (_ellipse742 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393302,
    rx: 0.85157,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 1052.54 880.056)",
    fill: "white"
  })), _ellipse743 || (_ellipse743 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851593,
    cy: 0.393302,
    rx: 0.851593,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 924.802 880.056)",
    fill: "white"
  })), _ellipse744 || (_ellipse744 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393302,
    rx: 0.85157,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 797.068 880.056)",
    fill: "white"
  })), _ellipse745 || (_ellipse745 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393302,
    rx: 0.85157,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 669.332 880.056)",
    fill: "white"
  })), _ellipse746 || (_ellipse746 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393302,
    rx: 0.851546,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 541.596 880.056)",
    fill: "white"
  })), _ellipse747 || (_ellipse747 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851593,
    cy: 0.393302,
    rx: 0.851593,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 413.862 880.056)",
    fill: "white"
  })), _ellipse748 || (_ellipse748 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851593,
    cy: 0.393302,
    rx: 0.851593,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 286.126 880.056)",
    fill: "white"
  })), _ellipse749 || (_ellipse749 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393302,
    rx: 0.851546,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 158.39 880.056)",
    fill: "white"
  })), _ellipse750 || (_ellipse750 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851567,
    cy: 0.393302,
    rx: 0.851567,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 1270.54 895.787)",
    fill: "white"
  })), _ellipse751 || (_ellipse751 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393302,
    rx: 0.851546,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 1142.8 895.787)",
    fill: "white"
  })), _ellipse752 || (_ellipse752 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851581,
    cy: 0.393302,
    rx: 0.851581,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 1015.07 895.787)",
    fill: "white"
  })), _ellipse753 || (_ellipse753 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393302,
    rx: 0.85157,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 887.333 895.787)",
    fill: "white"
  })), _ellipse754 || (_ellipse754 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393302,
    rx: 0.851546,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 759.597 895.787)",
    fill: "white"
  })), _ellipse755 || (_ellipse755 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393302,
    rx: 0.85157,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 631.863 895.787)",
    fill: "white"
  })), _ellipse756 || (_ellipse756 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85164,
    cy: 0.393302,
    rx: 0.85164,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 504.128 895.787)",
    fill: "white"
  })), _ellipse757 || (_ellipse757 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851593,
    cy: 0.393302,
    rx: 0.851593,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 376.392 895.787)",
    fill: "white"
  })), _ellipse758 || (_ellipse758 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393302,
    rx: 0.851546,
    ry: 0.393302,
    transform: "matrix(-1 0 0 1 248.656 895.787)",
    fill: "white"
  })), _ellipse759 || (_ellipse759 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70314,
    cy: 0.786561,
    rx: 1.70314,
    ry: 0.786561,
    transform: "matrix(-1 0 0 1 1308.86 869.044)",
    fill: "white"
  })), _ellipse760 || (_ellipse760 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70313,
    cy: 0.786518,
    rx: 1.70313,
    ry: 0.786518,
    transform: "matrix(-1 0 0 1 1053.39 872.978)",
    fill: "white"
  })), _ellipse761 || (_ellipse761 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70314,
    cy: 0.786561,
    rx: 1.70314,
    ry: 0.786561,
    transform: "matrix(-1 0 0 1 797.919 869.044)",
    fill: "white"
  })), _ellipse762 || (_ellipse762 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70314,
    cy: 0.786518,
    rx: 1.70314,
    ry: 0.786518,
    transform: "matrix(-1 0 0 1 542.449 865.112)",
    fill: "white"
  })), _ellipse763 || (_ellipse763 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70314,
    cy: 0.786561,
    rx: 1.70314,
    ry: 0.786561,
    transform: "matrix(-1 0 0 1 286.98 869.044)",
    fill: "white"
  })), _ellipse764 || (_ellipse764 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70314,
    cy: 0.786518,
    rx: 1.70314,
    ry: 0.786518,
    transform: "matrix(-1 0 0 1 134.548 901.764)",
    fill: "white"
  })), _ellipse765 || (_ellipse765 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851567,
    cy: 0.393259,
    rx: 0.851567,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 1321.63 906.168)",
    fill: "white"
  })), _ellipse766 || (_ellipse766 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393259,
    rx: 0.851546,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 1193.9 906.168)",
    fill: "white"
  })), _ellipse767 || (_ellipse767 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393259,
    rx: 0.85157,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 1066.16 906.168)",
    fill: "white"
  })), _ellipse768 || (_ellipse768 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851617,
    cy: 0.393259,
    rx: 0.851617,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 938.427 906.168)",
    fill: "white"
  })), _ellipse769 || (_ellipse769 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393259,
    rx: 0.85157,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 810.692 906.168)",
    fill: "white"
  })), _ellipse770 || (_ellipse770 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851476,
    cy: 0.393259,
    rx: 0.851476,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 682.956 906.168)",
    fill: "white"
  })), _ellipse771 || (_ellipse771 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85164,
    cy: 0.393259,
    rx: 0.85164,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 555.22 906.168)",
    fill: "white"
  })), _ellipse772 || (_ellipse772 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851593,
    cy: 0.393259,
    rx: 0.851593,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 427.487 906.168)",
    fill: "white"
  })), _ellipse773 || (_ellipse773 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851593,
    cy: 0.393259,
    rx: 0.851593,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 299.751 906.168)",
    fill: "white"
  })), _ellipse774 || (_ellipse774 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851593,
    cy: 0.393259,
    rx: 0.851593,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 299.751 906.168)",
    fill: "white"
  })), _ellipse775 || (_ellipse775 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851558,
    cy: 0.393259,
    rx: 0.851558,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 1279.05 910.101)",
    fill: "white"
  })), _ellipse776 || (_ellipse776 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851581,
    cy: 0.393259,
    rx: 0.851581,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 1151.32 910.101)",
    fill: "white"
  })), _ellipse777 || (_ellipse777 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851523,
    cy: 0.393259,
    rx: 0.851523,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 1023.58 910.101)",
    fill: "white"
  })), _ellipse778 || (_ellipse778 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393259,
    rx: 0.85157,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 895.849 910.101)",
    fill: "white"
  })), _ellipse779 || (_ellipse779 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393259,
    rx: 0.85157,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 768.113 910.101)",
    fill: "white"
  })), _ellipse780 || (_ellipse780 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393259,
    rx: 0.85157,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 640.379 910.101)",
    fill: "white"
  })), _ellipse781 || (_ellipse781 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85164,
    cy: 0.393259,
    rx: 0.85164,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 512.643 910.101)",
    fill: "white"
  })), _ellipse782 || (_ellipse782 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393259,
    rx: 0.851546,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 384.909 910.101)",
    fill: "white"
  })), _ellipse783 || (_ellipse783 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851593,
    cy: 0.393259,
    rx: 0.851593,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 257.173 910.101)",
    fill: "white"
  })), _ellipse784 || (_ellipse784 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851593,
    cy: 0.393259,
    rx: 0.851593,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 257.173 910.101)",
    fill: "white"
  })), _ellipse785 || (_ellipse785 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393216,
    rx: 0.851546,
    ry: 0.393216,
    transform: "matrix(-1 0 0 1 1207.52 886.506)",
    fill: "white"
  })), _ellipse786 || (_ellipse786 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393216,
    rx: 0.85157,
    ry: 0.393216,
    transform: "matrix(-1 0 0 1 1079.79 886.506)",
    fill: "white"
  })), _ellipse787 || (_ellipse787 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851617,
    cy: 0.393216,
    rx: 0.851617,
    ry: 0.393216,
    transform: "matrix(-1 0 0 1 952.053 886.506)",
    fill: "white"
  })), _ellipse788 || (_ellipse788 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393216,
    rx: 0.85157,
    ry: 0.393216,
    transform: "matrix(-1 0 0 1 824.317 886.506)",
    fill: "white"
  })), _ellipse789 || (_ellipse789 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393216,
    rx: 0.85157,
    ry: 0.393216,
    transform: "matrix(-1 0 0 1 696.583 886.506)",
    fill: "white"
  })), _ellipse790 || (_ellipse790 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851593,
    cy: 0.393216,
    rx: 0.851593,
    ry: 0.393216,
    transform: "matrix(-1 0 0 1 568.848 886.506)",
    fill: "white"
  })), _ellipse791 || (_ellipse791 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393216,
    rx: 0.851546,
    ry: 0.393216,
    transform: "matrix(-1 0 0 1 441.112 886.506)",
    fill: "white"
  })), _ellipse792 || (_ellipse792 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393216,
    rx: 0.851546,
    ry: 0.393216,
    transform: "matrix(-1 0 0 1 313.376 886.506)",
    fill: "white"
  })), _ellipse793 || (_ellipse793 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393259,
    rx: 0.85157,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 1241.59 925.832)",
    fill: "white"
  })), _ellipse794 || (_ellipse794 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393259,
    rx: 0.85157,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 1113.85 925.832)",
    fill: "white"
  })), _ellipse795 || (_ellipse795 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851535,
    cy: 0.393259,
    rx: 0.851535,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 986.115 925.832)",
    fill: "white"
  })), _ellipse796 || (_ellipse796 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393259,
    rx: 0.85157,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 858.381 925.832)",
    fill: "white"
  })), _ellipse797 || (_ellipse797 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85164,
    cy: 0.393259,
    rx: 0.85164,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 730.646 925.832)",
    fill: "white"
  })), _ellipse798 || (_ellipse798 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.85157,
    cy: 0.393259,
    rx: 0.85157,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 602.911 925.832)",
    fill: "white"
  })), _ellipse799 || (_ellipse799 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393259,
    rx: 0.851546,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 475.175 925.832)",
    fill: "white"
  })), _ellipse800 || (_ellipse800 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393259,
    rx: 0.851546,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 347.439 925.832)",
    fill: "white"
  })), _ellipse801 || (_ellipse801 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851546,
    cy: 0.393259,
    rx: 0.851546,
    ry: 0.393259,
    transform: "matrix(-1 0 0 1 347.439 925.832)",
    fill: "white"
  })), _ellipse802 || (_ellipse802 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.851593,
    cy: 0.393216,
    rx: 0.851593,
    ry: 0.393216,
    transform: "matrix(-1 0 0 1 185.643 886.506)",
    fill: "white"
  })), _ellipse803 || (_ellipse803 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70313,
    cy: 0.786518,
    rx: 1.70313,
    ry: 0.786518,
    transform: "matrix(-1 0 0 1 1146.21 901.449)",
    fill: "white"
  })), _ellipse804 || (_ellipse804 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70314,
    cy: 0.786518,
    rx: 1.70314,
    ry: 0.786518,
    transform: "matrix(-1 0 0 1 890.739 897.516)",
    fill: "white"
  })), _ellipse805 || (_ellipse805 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70307,
    cy: 0.786518,
    rx: 1.70307,
    ry: 0.786518,
    transform: "matrix(-1 0 0 1 635.27 893.585)",
    fill: "white"
  })), _ellipse806 || (_ellipse806 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70314,
    cy: 0.786518,
    rx: 1.70314,
    ry: 0.786518,
    transform: "matrix(-1 0 0 1 379.799 897.516)",
    fill: "white"
  })), _ellipse807 || (_ellipse807 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70313,
    cy: 0.786475,
    rx: 1.70313,
    ry: 0.786475,
    transform: "matrix(-1 0 0 1 1172.61 916.237)",
    fill: "white"
  })), _ellipse808 || (_ellipse808 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70309,
    cy: 0.786561,
    rx: 1.70309,
    ry: 0.786561,
    transform: "matrix(-1 0 0 1 917.138 912.303)",
    fill: "white"
  })), _ellipse809 || (_ellipse809 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70323,
    cy: 0.786561,
    rx: 1.70323,
    ry: 0.786561,
    transform: "matrix(-1 0 0 1 661.668 908.372)",
    fill: "white"
  })), _ellipse810 || (_ellipse810 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70309,
    cy: 0.786561,
    rx: 1.70309,
    ry: 0.786561,
    transform: "matrix(-1 0 0 1 406.198 912.303)",
    fill: "white"
  })), _ellipse811 || (_ellipse811 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.70314,
    cy: 0.786475,
    rx: 1.70314,
    ry: 0.786475,
    transform: "matrix(-1 0 0 1 150.726 916.237)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1e5081e0e1f9a65c3d3890751cb4907b.svg";
export { ForwardRef as ReactComponent };